import {Parcel} from "../functions/GlobalData";
import {useEffect} from "react";

export const useMapper = (data: any, selected: any[], key: string | number) => {
    const newArray: any = [];
    useEffect(() => {
        if (data) {
            selected.map((r: any) => {
                if (r) {
                    if (r[key] === data[key]) {
                        newArray.push(data);
                    } else {
                        newArray.push(r);
                    }
                }
            });
        }
    }, [data]);

    return newArray;
};
